<div class="trivia-host-container">
  <div class="page-container">
    <div *ngIf="gameOverMessage === '' && !currentQuestion">
      <h1>Welcome to the Trivia Game!</h1>

      <h2>To Join the game, please connect using this room code: <strong>{{ gameId }}</strong></h2>

      <h2>Players go to <a href="//alpha.tableflip.games/login" target="_blank"><strong>BIT.LY/TBLFLP</strong></a>on your favorite browser to join in on the fun!</h2>
    </div>

    <div *ngIf="gameOverMessage !== ''">
      <h1 class="game-over">{{ gameOverMessage }}</h1>

      <div class="game-over-btn-container">
        <button mat-raised-button color="primary" class="full-width" (click)="playAgain()">Play Again</button>
        <button mat-raised-button color="secondary" class="full-width" (click)="playAgain(false)">Choose Another Game</button>
      </div>
    </div>

    <div class="question-container" *ngIf="currentQuestion && gameOverMessage === ''">
      <h1>{{ currentQuestion.question }}</h1>
      <ul>
        <li *ngFor="let choice of currentQuestion.choices">
          {{ choice }}
        </li>
      </ul>
    </div>

    <div class="connected-users" *ngIf="connectedUsers.length > 0">
      <div class="user-list-container">
        <ul class="user-list">
          <li *ngFor="let connectedUser of connectedUsers">
            <img class="avatar" src="{{ connectedUser.avatar }}">
            <p class="username"><strong>{{ connectedUser.name }}</strong></p>
            <p class="score" [style.height]="getScoreHeight(connectedUser.currentScore)"><strong>{{ connectedUser.currentScore }}</strong></p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
